/* eslint-disable import/no-cycle */
import React, { createRef, useEffect, useState } from 'react';
// eslint-disable-next-line import/no-relative-packages
import { FPhi } from '../../scripts/selphID/selphid-widget-web.min';
import widget from '../../index';
import SelphiWidget from '../SelphiWidget/SelphiWidget';
import './SelphIDWidget.css';

function SelphIdWidget() {
  const FPhiCameraResolutions = {
    res480p: { title: '640x480', width: 640, height: 480 },
    res600p: { title: '800x600', width: 800, height: 600 },
    res768p: { title: '1024x768', width: 1024, height: 768 },
    res720p: { title: '1280x720 (720p)', width: 1280, height: 720 },
    res1080p: { title: '1920x1080 (1080p)', width: 1920, height: 1080 },
  };

  const [widgetPreviewCapture] = useState(true);
  const [widgetForceLandscape] = useState(false);
  const [widgetInitialTip] = useState(false);
  const [widgetDebugMode] = useState(false);
  const [widgetCameraWidth] = useState(FPhiCameraResolutions.res720p.width);
  const [widgetCameraHeight] = useState(FPhiCameraResolutions.res720p.height);
  const [widgetVideoRecord] = useState(false);
  const [widgetShowLog] = useState(false);
  const [widgetStartSimpleMode] = useState(false);
  const [widgetLicenseKey, setWidgetLicenseKey] = useState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

  // Custom Code
  const generateRequest = {
    facialDocument: '',
    facialImage: '',
  };

  // Widget event handlers
  const onModuleLoaded = (eventData) => console.warn('[SelphID] onModuleLoaded', eventData);

  const onExtractionFinished = (extractionResult) => {
    console.warn('[SelphID] onExtractionFinished', extractionResult);

    const docCaptured = extractionResult.detail.extractionData || null;

    if (docCaptured !== undefined && docCaptured !== null) {
      if (docCaptured.documentId !== null) {
        generateRequest.metadata = { dni: docCaptured.documentId };
      }
      generateRequest.facialDocument = extractionResult.detail.images.faceImage.slice(23);
      widget.render(<SelphiWidget generateRequest={generateRequest} generateFlow />);
    }
  };

  const onUserCancelled = () => {
    console.warn('[SelphID] onUserCancelled');
  };

  const onExceptionCaptured = (exceptionResult) => {
    console.warn('[SelphID] onExceptionCaptured', exceptionResult);
    console.log(`exceptionType: ${exceptionResult.detail.exceptionType}`);
    console.log(`exceptionMessage: ${exceptionResult.detail.message}`);
  };

  const onExtractionTimeout = (eventInfo) => {
    console.warn('[SelphID] onExtractionTimeout', eventInfo);
  };

  const onTrackStatus = (eventData) => {
    const trackStatusCode = Object.entries(FPhi.SelphID.TrackStatus)
      .find((e) => e[1] === eventData.detail.code);
    console.warn(`[SelphID] onTrackStatus (Code: ${trackStatusCode[1]} - ${trackStatusCode[0]}, Timestamp: ${eventData.detail.timeStamp}`);
    console.log(eventData);
  };

  // Create references
  const widgetRef = createRef();

  useEffect(() => {
    const node = widgetRef.current;

    node.addWidgetEventListener('onModuleLoaded', onModuleLoaded);
    node.addWidgetEventListener('onExtractionFinished', onExtractionFinished);
    node.addWidgetEventListener('onUserCancelled', onUserCancelled);
    node.addWidgetEventListener('onExceptionCaptured', onExceptionCaptured);
    node.addWidgetEventListener('onExtractionTimeout', onExtractionTimeout);
    node.addWidgetEventListener('onTrackStatus', onTrackStatus);

    if (widgetLicenseKey === '') {
      // eslint-disable-next-line no-alert
      setWidgetLicenseKey(window.prompt('Please, enter the license key before start the operations: ', ''));
    }
  }, [widgetRef, widgetLicenseKey]);

  return (
    <div className="m-3 div-selphid" id="child-selphid">
      <div className="row h-100 text-center d-flex justify-content-center">
        {/* Widget web SelphID */}
        <div className="col-12 col-md-9">
          <facephi-selphid
            ref={widgetRef}
            className="bg-dark"
            language="en"
            documentAspectRatio={85.60 / 53.98}
            bundlePath="../../assets/selphid"
            previewCapture={widgetPreviewCapture}
            forceLandscape={widgetForceLandscape}
            initialTip={widgetInitialTip}
            licenseKey={widgetLicenseKey}
            imageFormat="image/jpeg"
            style={{
              width: '100%',
              height: widgetForceLandscape ? '56.25%' : '90%',
            }}
            cameraWidth={widgetCameraWidth}
            cameraHeight={widgetCameraHeight}
            specificData="ES"
            videoRecord={widgetVideoRecord}
            videoRecordType={FPhi.SelphID.RecorderType.Remote}
            videoRecordScale={widgetCameraWidth < 1280 ? 1 : 0.5}
            showLog={widgetShowLog}
            debugMode={widgetDebugMode}
            startSimpleMode={widgetStartSimpleMode}
          />
        </div>
      </div>
    </div>
  );
}

export default SelphIdWidget;
